/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var FxIdDomainStoreEnumsOrderState;
(function (FxIdDomainStoreEnumsOrderState) {
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["Created"] = 0] = "Created";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["WaitingForPayment"] = 1] = "WaitingForPayment";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["PayedWaitingForSending"] = 2] = "PayedWaitingForSending";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["CancelledPaid"] = 898] = "CancelledPaid";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["Cancelled"] = 899] = "Cancelled";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["Completed"] = 999] = "Completed";
    FxIdDomainStoreEnumsOrderState[FxIdDomainStoreEnumsOrderState["NUMBER_unknown_default_open_api"] = 11184809] = "NUMBER_unknown_default_open_api";
})(FxIdDomainStoreEnumsOrderState || (FxIdDomainStoreEnumsOrderState = {}));
export function instanceOfFxIdDomainStoreEnumsOrderState(value) {
    for (const key in FxIdDomainStoreEnumsOrderState) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainStoreEnumsOrderState, key)) {
            if (FxIdDomainStoreEnumsOrderState[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function FxIdDomainStoreEnumsOrderStateFromJSON(json) {
    return FxIdDomainStoreEnumsOrderStateFromJSONTyped(json, false);
}
export function FxIdDomainStoreEnumsOrderStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FxIdDomainStoreEnumsOrderStateToJSON(value) {
    return value;
}
export function FxIdDomainStoreEnumsOrderStateToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=FxIdDomainStoreEnumsOrderState.js.map